module.exports = __webpack_public_path__ + "img/maintainance.71d63ea5.png";